const config = {
    target: '.js-contribute',
    trigger: '.js-contribute__trigger',
    activeClass: 'is-active'
};

$(config.trigger).on('click', function(e) {
    e.preventDefault();
    $(this).parent(config.target).toggleClass(config.activeClass);
});



// WEBPACK FOOTER //
// ./src/js/components/contribute.js